












































































import { Component } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import Confirm from "@/shared/components/confirm.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import { dateFormatterSemHoras } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { FiltroCupom, CupomService, Cupom } from "@/services/cupom.service";
import Manter from "./Manter.vue";

@Component({
  components: { DataTable, Tooltip, DatePicker, Manter, Confirm },
  filters: { dateFormatterSemHoras },
})
export default class Cupons extends mixins(GlobalMixin) {
  loading = false;
  promise: Promise<Cupom[]> | null = null;

  headers = [
    { value: "codCupom", text: "Cupom" },
    { value: "descricao", text: "Descrição" },
    { value: "nomeParceiro", text: "Parceiro" },
    { value: "qtdLimite", text: "Qtd. Limite" },
    { value: "qtdUsados", text: "Qtd. Usados" },
    { value: "dataInicio", text: "Data Início" },
    { value: "dataFim", text: "Data Fim" },
    { value: "porcentagemDescontoCupom", text: "Desconto (%)" },
    { value: "porcentagemParceiro", text: "Parceiro (%)" },
    { value: "apenasPrimeiroPlano", text: "1° Plano" },
    { value: "ativo", text: "Ativo" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  filtros: FiltroCupom = {
    codCupom: "",
    termParceiro: "",
    semParceiro: false,
    soAtivos: true,
  };

  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.novoCupom();
    this.fetchCupons();
  }

  async editarItem(cupom: Cupom) {
    const modal = this.$refs.manter as Manter;
    await modal.editarCupom(cupom.idCupom);
    this.fetchCupons();
  }
  async deletarItem(cupom: Cupom) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir cupom ${cupom.codCupom}`;
    const text = `Deseja realmente deletar o cupom ${cupom.codCupom} ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await CupomService.deletarCupom(cupom.idCupom).finally(this.stopLoader);
      this.fetchCupons();
    }
  }

  async desativarItem(cupom: Cupom) {
    const modalConfirm = this.$refs.confirm as Confirm;
    if (cupom.ativo) {
      const title = `Desativar cupom ${cupom.codCupom}`;
      const text = `Deseja realmente desativar o cupom ${cupom.codCupom} ?`;
      const res = await modalConfirm.open(title, text);
      if (res) {
        this.startLoader();
        cupom = await CupomService.obter(cupom.idCupom);
        cupom.ativo = false;
        const ids = cupom.tiposPlanos.map((x) => x.idTipoPlano);
        await CupomService.manter(cupom, ids).finally(this.stopLoader);
        this.fetchCupons();
      }
    }
  }

  mounted() {
    this.fetchCupons();
  }

  fetchCupons() {
    this.loading = true;
    this.promise = CupomService.listarCupons(this.filtros);
    this.loading = false;
  }
}
